import { render, staticRenderFns } from "./RegulatoryAffairsTabComponent.vue?vue&type=template&id=548607c6&scoped=true&"
import script from "./RegulatoryAffairsTabComponent.vue?vue&type=script&lang=js&"
export * from "./RegulatoryAffairsTabComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548607c6",
  null
  
)

export default component.exports